import { rankWith, isDateControl } from '@jsonforms/core';
import type { ControlProps } from '@jsonforms/core';
import { withJsonFormsControlProps } from '@jsonforms/react';
import { InputControlComponent } from 'src/components/JsonForm/controls/InputControl';
import { useEvent } from 'src/hooks/useEvent';

export const DateControlComponent = (props: ControlProps) => {
    const showPicker = useEvent((e: React.FocusEvent<HTMLInputElement>) => {
        e.target.showPicker();
    });
    return <InputControlComponent {...props} type="date" onFocus={showPicker} />;
};

export const DateControlTester = rankWith(
    5, //increase rank as needed
    isDateControl,
);

export const DateControl = withJsonFormsControlProps(DateControlComponent);
